<template>
  <div class="topBar">
    <div class="openMenus">
      <el-button
        type="success"
        :icon="Expand"
        size="large"
        circle
        @click="this.isCollapse = !this.isCollapse"
      />
      <!--      <el-button type="success" :icon="Check" circle />-->
    </div>
    <div class="logo">
      <router-link :to="'/'"><img src="@/static/logo.png" /></router-link>
    </div>
  </div>
  <div class="panel">
    <div class="panel_left">
      <el-menu
        default-active="1"
        class="el-menu-vertical-demo"
        :collapse="isCollapse"
        @open="handleOpen"
        @close="handleClose"
      >
        <router-link :to="'/admin/aabb/audit'" v-if="status == 2 || status == 1"
          ><el-menu-item index="1">
            <el-icon><setting /></el-icon>
            <template #title>审核管理</template>
          </el-menu-item></router-link
        >
        <router-link :to="'/admin/aabb/personnel'" v-if="status == 1"
          ><el-menu-item index="2">
            <el-icon><document /></el-icon>
            <template #title> 人员管理 </template>
          </el-menu-item></router-link
        >
        <router-link :to="'/admin/aabb/apply'" v-if="status == 2 || status == 1"
          ><el-menu-item index="3">
            <el-icon><SwitchFilled /></el-icon>
            <template #title> 创作管理 </template>
          </el-menu-item></router-link
        >
      </el-menu>
    </div>
    <div class="panel_right">
      <el-scrollbar>
        <router-view class="rv" />
      </el-scrollbar>
    </div>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  computed,
  watch,
  onMounted,
  onUnmounted,
} from "vue";
import {
  Document,
  Menu as IconMenu,
  Location,
  Setting,
  Check,
  SwitchFilled,
  Expand,
} from "@element-plus/icons-vue";

export default defineComponent({
  name: "App",
  data(): any {
    return {
      isCollapse: false,
    };
  },
  components: {
    Document,
    IconMenu,
    Location,
    Setting,
    Check,
    SwitchFilled,
  },
  computed: {
    Expand() {
      return Expand;
    },
    Check() {
      return Check;
    },
    status(): number {
      return this.$store.state.user.status;
    },
  },
  watch: {},
  mounted() {},
  methods: {
    handleOpen: (key: string, keyPath: string[]) => {},
    handleClose: (key: string, keyPath: string[]) => {},
  },
});
</script>

<style lang="less" scoped>
.topBar {
  width: 100%;
  height: 100px;
  border-bottom: 1px solid rgba(159, 133, 133, 0.77);
  box-sizing: border-box;
  padding: 20px;
  position: fixed;
  z-index: 100;
  background: #fff;

  .openMenus {
    width: 100px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    float: left;
  }

  .logo {
    height: 100%;
    width: 10%;
    float: left;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 20px;

    img {
      width: 100%;
      min-width: 120px;
      max-width: 180px;
    }
  }

  .backto {
    float: right;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    label {
      background: #ffffff;
      box-sizing: border-box;
      padding: 20px;
      border-radius: 25px;
      box-shadow: 2px 2px 2px 2px #c9c9c9;
    }

    &:hover {
      label {
        background: #a9a6fc;
        color: #fff;
      }
    }
  }
}

.panel {
  display: grid; /* 使用Grid布局 */
  grid-template-columns: auto 1fr; /* 第一列宽度自动，第二列占据剩余空间 */
  width: 100%;
  height: 100vh;
  overflow: hidden;

  &_left {
    width: auto;
    height: 100%;
    max-width: 200px;
    float: left;
    margin-top: 100px;
  }

  &_right {
    height: 100%;
    overflow: auto;
    overflow-x: hidden;

    .rv {
      width: 100%;
      overflow: scroll;
    }
  }
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
  height: 100%;
}

.el-menu {
  height: 100%;
}

@media screen and (max-width: 700px) {
  .topBar {
    .changeBar {
      display: block;
    }
  }
}
</style>
